const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

const authHeaders = (token) => ({
  'Content-Type': 'application/json',
  Authorization: `Bearer ${token}`,
});

async function parseResponse(response) {
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.error || data.errors?.[0]?.msg || 'Request failed');
  }
  return data;
}

export async function employerSignup(payload) {
  const response = await fetch(`${API_BASE}/auth/employer-signup`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  return parseResponse(response);
}

export async function employerSignin(payload) {
  const response = await fetch(`${API_BASE}/auth/employer-signin`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  return parseResponse(response);
}

export async function saveCompany(token, company) {
  const response = await fetch(`${API_BASE}/companies/me`, {
    method: 'POST',
    headers: authHeaders(token),
    body: JSON.stringify(company),
  });
  return parseResponse(response);
}

export async function uploadCompanyLogo(token, file) {
  const formData = new FormData();
  formData.append('logo', file);
  const response = await fetch(`${API_BASE}/companies/me/logo`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}` },
    body: formData,
  });
  return parseResponse(response);
}

export async function uploadJobJd(token, file) {
  const formData = new FormData();
  formData.append('jd', file);
  const response = await fetch(`${API_BASE}/post-job/jd`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}` },
    body: formData,
  });
  return parseResponse(response);
}

export async function getCompany(token) {
  const response = await fetch(`${API_BASE}/companies/me`, {
    headers: authHeaders(token),
  });
  return parseResponse(response);
}

export async function saveJobDraft(token, job) {
  const response = await fetch(`${API_BASE}/post-job/draft`, {
    method: 'POST',
    headers: authHeaders(token),
    body: JSON.stringify(job),
  });
  return parseResponse(response);
}

export async function getMyJobPostings(token) {
  const response = await fetch(`${API_BASE}/post-job/mine`, {
    headers: authHeaders(token),
  });
  return parseResponse(response);
}

export async function createJobPayment(token, payload) {
  const response = await fetch(`${API_BASE}/payment/create-payment`, {
    method: 'POST',
    headers: authHeaders(token),
    body: JSON.stringify({ type: 'job_posting', ...payload }),
  });
  return parseResponse(response);
}

export async function completePayment(token, orderId, sessionId) {
  const response = await fetch(`${API_BASE}/payment/complete/${orderId}`, {
    method: 'POST',
    headers: authHeaders(token),
    body: JSON.stringify({ sessionId }),
  });
  return parseResponse(response);
}

export async function getPaymentOrder(token, orderId) {
  const response = await fetch(`${API_BASE}/payment/order/${orderId}`, {
    headers: authHeaders(token),
  });
  return parseResponse(response);
}

export async function confirmCryptoPayment(token, orderId) {
  const response = await fetch(`${API_BASE}/payment/confirm/${orderId}`, {
    method: 'POST',
    headers: authHeaders(token),
  });
  return parseResponse(response);
}
